import Vue from 'vue/dist/vue.min.js';
import {specsTableTemplate} from './spec-table';
import EventBus from './event-bus';
import store from './store';

const HeroProduct = () => {

    const heros = document.querySelectorAll('.hero-products');

    const heroProductConstructor = (id) => {
        Vue.component('hero-product-template', {
            data: function() {
                return {
                    sizeSelect: null,
                    viewConfig: null,
                    gallery: null,
                    galleryItems: [],
                    selectedImage: 1,
                    selectedItem: null //product name for passing to child spec table component
                }
            },
            watch: {
                selectedImage: function() {

                },
            },
            methods: {
                init() {
                    // assign unique ID to each gallery item
                    // if multiple images, set gallery array
                    if (this.$el.querySelectorAll('.hero-products__gallery-image').length > 1) {
                        this.gallery = true;

                        // push images and their heights to array
                        this.$el.querySelectorAll('.hero-products__gallery-image').forEach((item, index) => {
                            item.dataset.id = index + 1;
                            // console.log(item.clientHeight);
                            this.galleryItems.push({
                                src: item.src,
                            });
                        });
                    } else {
                        // if only one image, set id to 1 (the default selected image id)
                        this.$el.querySelector('.hero-products__gallery-image').dataset.id = 1;
                    }

                    this.selectedItem = this.$refs.title ? this.$refs.title.innerText : null;
                },
                handleImageSelect(id) {
                    this.selectedImage = id;
                },
            },
            mounted() {
                this.init();
                // recieve selected gallery item from child
                EventBus.$on('selectedImage', (id) => {
                    this.handleImageSelect(id);
                });
            }
        });

        Vue.component('hero-products-image', {
            props: ['selectedImage'],
            data: function() {
                return {
                    id: null,
                    isActive: false
                }
            },
            watch: {
                selectedImage: function() {
                    this.isActive = this.selectedImage == this.id ? true : false;
                }
            },
            methods: {

            },
            mounted() {
                this.$nextTick(() => {
                    this.id = this.$el.dataset.id;
                    this.isActive = this.selectedImage == this.id ? true : false;
                });
            }
        });

        Vue.component('hero-products-thumbnails', {
            props: ['galleryItems', 'selectedImage'],
            data: function() {
                return {
                }
            },
            template: `
            <ul class="hero-products__thumbnail-container">
                <hero-products-thumbnail-item v-for="(item, index) in galleryItems" :image="item.src" :id="index + 1" :selected-image="selectedImage" :key="index"/>
            </ul>
            `,
            methods: {

            },
            mounted() {

            }
        });

        Vue.component('hero-products-thumbnail-item', {
            props: ['image', 'id', 'selectedImage'],
            data: function() {
                return {
                    isActive: false
                }
            },
            computed: {
                imageUrl: function() {
                    return `url('${this.image}')`
                }
            },
            watch: {
                selectedImage: function() {
                    this.isActive = this.selectedImage == this.id ? true : false ;
                }
            },
            template: `
            <li class="hero-products__thumbnail-item" v-bind:style="{backgroundImage: imageUrl}" v-on:click="selectImage" :class="{active: isActive}"></li>
            `,
            methods: {
                selectImage() {
                    // emit id of clicked element to parent
                    EventBus.$emit('selectedImage', this.id);
                }
            },
            mounted() {
                this.isActive = this.selectedImage == this.id ? true : false ;
            }
        });

        new Vue({
            el: `.hero-products-${id}`,
            store: store
        }).$mount(`.hero-products-${id}`, true);
    }

    specsTableTemplate();

    if (heros.length > 0) {
        heros.forEach((item, index) => {
            item.classList.add(`hero-products-${index}`);
            heroProductConstructor(index);
        })
    }

}

export default HeroProduct;